import type { ReactElement, ReactNode } from 'react';
import { POPOVER_CLOSE_BACKGROUND, } from './Cmarkdowntable.constants';
import { Cbutton } from '@/components/ui/Cbutton';
import { ButtonPreset } from '@/constants/componentPresets';
interface CmarkdowntablePopoverActionButtonProps {
    dataName: string;
    ariaLabel: string;
    idleColor: string;
    hoverColor: string;
    onClick: () => void;
    children: ReactNode;
}
export function CmarkdowntablePopoverActionButton({ dataName, ariaLabel, idleColor, hoverColor, onClick, children, }: CmarkdowntablePopoverActionButtonProps): ReactElement {
    return (
      <Cbutton preset={ButtonPreset.Ghost} onClick={onClick} ariaLabel={ariaLabel} padding={0} radius={5} containerStyle={{
            color: idleColor,
            width: 22,
            height: 22,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 5,
            backgroundColor: 'transparent',
            backgroundImage: 'none',
            transition: 'background 0.12s, color 0.12s',
        }} stateContainerStyle={{ hover: { backgroundColor: POPOVER_CLOSE_BACKGROUND.Hover, color: hoverColor } }}>
        <span>{children}</span>
      </Cbutton>
    );
}
